module.exports = __webpack_public_path__ + "static/media/5.64e776be.jpg";